import {switchBaseLayer} from './actions';
import {toggleDataLayer} from '../dataLayers/actions';
import LayerSelect from '../components/layers';
import { connect } from 'react-redux';

const mapStateToProps = (state) => {

  return {
    dataLayers: {},
  	activeLayer: state.baseLayers.active,
	  mapLayers: state.baseLayers.layers
  };
};

const mapDispatchToProps = (dispatch) => {

  return {
    switchMapHandler: layer => {
      dispatch(switchBaseLayer(layer));
    },
    toggleDataLayer: (layer, visibility) => {
      dispatch(toggleDataLayer(layer, visibility));
    }
  };
};

const baseLayersContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(LayerSelect);

export default baseLayersContainer;